import * as React from "react";
import { color, styled } from "@mui/system";
import TextField from "@mui/material/TextField";
import { TextareaAutosize } from "@mui/material";

export const CustomTextInputLeftAligned = styled(TextField)({
  color: "#AF3241",
  fontSize: "14px",
  "& .MuiInput-input": {
    color: "#AF3241",
    textAlign: "left",
    fontSize: "14px",
    padding: "0px",
  },
  "& .MuiInputLabel-root": {
    color: "#AF3241",
    fontSize: "14px",
  },
  "& .MuiInputLabel-root.Mui-focused": {
    color: "#AF3241",
  },
  "& .MuiInput-underline::before": {
    borderColor: "#AF3241",
  },
  "& .MuiInput-underline::after": {
    borderColor: "#AF3241",
  },
  "& .MuiFormLabel-root.MuiInputLabel-root": {
    color: "#AF3241",
  }
});

// center alinged text intput
export const CustomTextInputCenterAligned = styled(TextField)({
  color: "#AF3241",
  fontSize: "14px",
  "& .MuiInput-input": {
    color: "#AF3241",
    textAlign: "center",
    fontSize: "14px",
    padding: "0px",
  },
  "& .MuiInputLabel-root": {
    color: "#AF3241",
    fontSize: "14px",
  },
  "& .MuiInputLabel-root.Mui-focused": {
    color: "#AF3241",
  },
  "& .MuiInput-underline::before": {
    borderColor: "#AF3241",
  },
  "& .MuiInput-underline::after": {
    borderColor: "#AF3241",
  },
  "& .MuiFormLabel-root.MuiInputLabel-root": {
    color: "#AF3241",
  }
});

// Create a styled component for the custom input
export const CustomTextInput = styled(TextField)({
  color: "#AF3241",
  fontSize: "13px",
  "& .MuiInput-input": {
    color: "#AF3241",
  },
  "& .MuiInputLabel-root": {
    color: "#AF3241",
    fontSize: "14px",
  },
  "& .MuiInputLabel-formControl": {
    color: "#AF3241",
  },
  "& .MuiInputLabel-root.Mui-focused": {
    color: "#AF3241",
  },
  "& .MuiInput-underline::before": {
    borderColor: "#AF3241",
  },
  "& .MuiInput-underline::after": {
    borderColor: "#AF3241",
  },
  "& .MuiFormLabel-root.MuiInputLabel-root": {
    color: "#AF3241",
  },
  // "& .MuiInputBase-root.MuiInput-root.MuiInput-underline":{
  //   marginTop: "17px",
  // }
});

// styled text area autosize input
export const CustomTextAreaInput = styled(TextareaAutosize)({
  color: "#AF3241",
  fontSize: "13px",
  "& .MuiInput-input": {
    color: "#AF3241",
  },
  "& .MuiInputLabel-root": {
    color: "#AF3241",
    fontSize: "14px",
  },
  "& .MuiInputLabel-root.Mui-focused": {
    color: "#AF3241",
  },
  "& .MuiInput-underline::before": {
    borderColor: "#AF3241",
  },
  "& .MuiInput-underline::after": {
    borderColor: "#AF3241",
  },
  "& .MuiFormLabel-root.MuiInputLabel-root": {
    color: "#AF3241",
  }
});

export const CustomWhiteColoredInput = styled(TextField)({
  color: "#fff",
  "& .MuiInput-input": {
    color: "#fff",
  },
  "& .MuiInputLabel-root": {
    color: "#fff",
  },
  "& .MuiInputLabel-root.Mui-focused": {
    color: "#fff",
  },
  "& .MuiInput-underline::before": {
    borderColor: "#fff",
  },
  "& .MuiInput-underline::after": {
    borderColor: "#fff",
  },
});

export const StyledDateTextField = styled(TextField)({
  "& .MuiInput-input": {
    color: "#AF3241",
    fontSize: "15.305px",
    cursor: "text",
    caretColor: "#AF3241",
    "&::selection": {
      backgroundColor: "rgba(175, 50, 65, 0.3)",
    },
  },
  "& .MuiInputLabel-root": {
    color: "#AF3241",
    fontSize: "14px",
  },
  "& .MuiInputLabel-root.Mui-focused": {
    color: "#AF3241",
  },
  "& .MuiInput-underline::before": {
    borderColor: "#AF3241",
  },
  "& .MuiInput-underline:hover:not(.Mui-disabled)::before": {
    borderColor: "#AF3241",
  },
  "& .MuiInput-underline::after": {
    borderColor: "#AF3241",
  },
  "& .MuiInputAdornment-root": {
    display: "none",
  },
});
